import { $$ } from 'utils/dom';
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import { viewport } from '../getViewport';

export const storyFacts = () => {
  const facts = $$('.story-facts');

  if (facts.length) {
    facts.forEach(fact => {
      const items = $$('.story-facts__item', fact);
      const timeline = gsap.timeline();

      items.forEach(item => {
        gsap.set(item, {
          y: viewport.isReduced
            ? 0
            : viewport.isDesktop
            ? 50
            : viewport.isTablet
            ? 50
            : viewport.isMobile
            ? 0
            : '',
        });

        timeline.to(item, {
          y: 0,
          stagger: {
            each: 1,
          },
        });
      });

      ScrollTrigger.create({
        animation: timeline,
        trigger: fact,
        start: () => 'top 60%',
        end: () => 'top 40%',
        toggleActions: 'play pause resume reset',
        scrub: 1,
      });
    });
  }
};
